module.exports = __webpack_public_path__ + "static/media/round_error_blue.6d6dfa7a.svg";